import React from 'react';
import classNames from 'classnames';
import css from './BlueLayout.module.css';
import { useAuthBtn } from '../use-auth-btn';
import metaLogoSrc from 'assets/meta-partner.png';
import leaderLogoSrc from 'assets/LeaderWinter22.png';
import moneyBackSrc from 'assets/money-back-guarantee.png';
import { Logo } from '../../../../../layout/BotBuilderSidebar/Logo/Logo';
import { LeaderBadge } from '../components/Badges/LeaderBadge';
import loginIllustrationSrc from 'assets/login-illustration.png';

type Props = {
  className?: string;
  children?: any;
  hideTrial?: boolean;
};

export const BlueLayout = ({ className, children, hideTrial }: Props) => {
  const { isSignIn, isLogIn, isResetPassword } = useAuthBtn();

  const isLoginLike = isSignIn || isLogIn || isResetPassword;

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <Logo className={css.desktopLogo} />
        <div className={css.left}>
          <div className={css.description}>
            <div
              className={classNames(css.headlineContainer, {
                [css.signInHeadlineContainer]: isLoginLike,
              })}
            >
              <div className={css.headline}>
                <span>
                  {isLoginLike
                    ? 'Check your new leads!'
                    : 'See how many leads you can get from your website'}
                </span>

                <span className={css.subtitle}>
                  {isLoginLike
                    ? 'Automatically acquire the contact information of your anonymous website visitors'
                    : 'Capture contact information automatically from your website traffic.'}
                </span>
              </div>
              {isLoginLike && (
                <div>
                  <img src={loginIllustrationSrc} className={css.loginImage} />
                </div>
              )}
              {!isLoginLike && (
                <div className={css.badges}>
                  <img src={leaderLogoSrc} className={css.meta} />
                  <img src={metaLogoSrc} className={css.meta} />
                  <img src={moneyBackSrc} className={css.meta} />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={classNames(css.right)}>
          {isLoginLike && (
            <div className={css.badges}>
              <LeaderBadge className={css.leader} whiteStyle />
              <img src={metaLogoSrc} className={css.badge} />
            </div>
          )}
          <Logo
            className={classNames(css.logo, { [css.signupLogo]: !isLoginLike })}
          />
          {children}
        </div>
      </div>
    </div>
  );
};
